import { LobbyImage } from '@colonist/types';
import { showSimpleDialog } from '../../../../shared/scripts/ui_popup/showSimpleDialog.ts';
import { UIMRoomPageController } from './UIMRoomPageController.ts';
import { UIMRoomEditPageController } from './UIMRoomEditPageController.ts';
import { UIMRoomSetupPageController } from './UIMRoomSetupPageController.ts';
import { SocketLobbySend } from '../../../../shared/scripts/socket/SocketLobbySend.ts';
import { RoomType } from '@colonist/lobby-types';
import { UIUrlController } from '../../../../shared/scripts/ui_html/UIUrlController.ts';
import { notificationController, socket } from '../../../../shared/scripts/EntryShared.ts';
import { UIOnlineFriendController } from '../../../../shared/scripts/ui_friends/UIOnlineFriendController.ts';
import { UIRoomSettingsController } from '../../../../shared/scripts/ui_room/UIRoomSettingsController.ts';
import { RoomStateChangerNotifier } from '../../../../shared/scripts/RoomStateChangerNotifier.ts';
import { clientI18n } from '../../../../shared/scripts/ClientI18n.ts';
import { ModeSettingEnum } from '@colonist/game-base-types';
import { UIUtilsEjsVariables } from '../../../../shared/scripts/UIUtilsEjsVariables.ts';
import { UIMDiscordActivityController } from '../../discord/UIMDiscordActivityController.ts';
export var RoomStep = /*#__PURE__*/ function(RoomStep) {
    RoomStep[RoomStep["RoomPage"] = 0] = "RoomPage";
    RoomStep[RoomStep["EditRoom"] = 1] = "EditRoom";
    RoomStep[RoomStep["SetupRoom"] = 2] = "SetupRoom";
    return RoomStep;
}({});
export class UIMCreateRoomController {
    init() {
        socket.controller.registerSessionEstablishedObserver(()=>{
            if (this.isUserOnCreateRoomFlow() && this.roomState != undefined) {
                this.handleSocketReconnection();
            }
        });
    }
    updateRoomState(roomState) {
        var _this_roomState;
        const hadRoom = this.roomState != undefined;
        const isSameRoom = roomState.gameSetting.id == ((_this_roomState = this.roomState) === null || _this_roomState === void 0 ? void 0 : _this_roomState.gameSetting.id);
        const isReceivedRoomStateOlder = isSameRoom && roomState.updateSequence < this.roomState.updateSequence;
        if (isReceivedRoomStateOlder) return;
        RoomStateChangerNotifier.run(this.roomState, roomState);
        this.roomState = roomState;
        this.updateAllControllersWithRoomState();
        this.initNextStepForRoomCreationFlow(!isSameRoom && hadRoom);
        this.showPageOnNextUpdate();
    }
    onKickedInactiveHost() {
        if (this.roomState.isHost(socket.controller.session.id)) {
            const text = clientI18n.t('strings:roomPage.notifications.kickedDueToInactivity');
            this.receivedChatSystemMessage(text);
        }
        notificationController.showNotification(LobbyImage.Lightning, {
            key: 'strings:roomPage.notifications.kickingInactiveHost'
        });
    }
    updateAllControllersWithRoomState() {
        var _this_roomSetupController, _this_roomEditPageController, _this_roomPageController;
        (_this_roomSetupController = this.roomSetupController) === null || _this_roomSetupController === void 0 ? void 0 : _this_roomSetupController.update(this.roomState);
        (_this_roomEditPageController = this.roomEditPageController) === null || _this_roomEditPageController === void 0 ? void 0 : _this_roomEditPageController.update(this.roomState);
        (_this_roomPageController = this.roomPageController) === null || _this_roomPageController === void 0 ? void 0 : _this_roomPageController.update(this.roomState);
    }
    initNextStepForRoomCreationFlow(forceRoomPage) {
        const userOnCreateRoomFlow = this.pageOnNextUpdate == undefined || forceRoomPage;
        if (userOnCreateRoomFlow) this.pageOnNextUpdate = 0;
    }
    showPageOnNextUpdate(activeTabIndex) {
        window.history.replaceState(null, '', '#' + this.roomState.gameSetting.id);
        switch(this.pageOnNextUpdate){
            case 2:
                return this.showSetupScreen(activeTabIndex);
            case 1:
                return this.showEditRoomScreen(activeTabIndex);
            case 0:
                return this.showActiveRoomScreen(activeTabIndex);
            default:
                return;
        }
    }
    showActiveRoomScreen(tabIndex) {
        if (this.roomPageController == undefined) this.roomPageController = new UIMRoomPageController(this.roomState);
        UIOnlineFriendController.userEnteredRoom();
        this.showRoomStep(this.roomPageController);
        this.roomPageController.showView(tabIndex);
        this.openDiscordInviteFriendsDialogIfNeeded();
    }
    openDiscordInviteFriendsDialogIfNeeded() {
        if (!this.shouldOpenDiscordInviteOnEnteringRoomView) return;
        this.shouldOpenDiscordInviteOnEnteringRoomView = false;
        UIMDiscordActivityController.getInstance().openInviteFriendsDialogIfAllowed();
    }
    showEditRoomScreen(tabIndex) {
        if (this.roomEditPageController == undefined) this.roomEditPageController = new UIMRoomEditPageController(this.roomState);
        this.showRoomStep(this.roomEditPageController);
        this.roomEditPageController.showView(tabIndex);
    }
    showSetupScreen(tabIndex) {
        if (this.roomSetupController == undefined) this.roomSetupController = new UIMRoomSetupPageController(this.roomState);
        this.showRoomStep(this.roomSetupController);
        this.roomSetupController.showView(tabIndex);
    }
    receivedChatMessage(message, senderUsername, senderIcon) {
        var _this_roomPageController;
        (_this_roomPageController = this.roomPageController) === null || _this_roomPageController === void 0 ? void 0 : _this_roomPageController.receivedChatMessage(senderIcon, message, senderUsername);
    }
    receivedChatSystemMessage(message) {
        var _this_roomPageController;
        (_this_roomPageController = this.roomPageController) === null || _this_roomPageController === void 0 ? void 0 : _this_roomPageController.receivedChatMessage(LobbyImage.Lightning, message);
    }
    setShowPageOnNextUpdate(page, forceUpdate = false, activeTabIndex) {
        this.pageOnNextUpdate = page;
        if (forceUpdate) this.showPageOnNextUpdate(activeTabIndex);
    }
    initCreateRoomView() {
        this.pageOnNextUpdate = 2;
        this.shouldOpenDiscordInviteOnEnteringRoomView = UIUtilsEjsVariables.isUserOnDiscord;
        this.createRoom();
        setTimeout(()=>UIRoomSettingsController.initRoomSettingFromLocalStorage(ModeSettingEnum.Classic4P), 500);
    }
    // eslint-disable-next-line class-methods-use-this
    createRoom() {
        if (UIUtilsEjsVariables.isUserOnDiscord) {
            const channelId = UIMDiscordActivityController.getInstance().voiceChannelId;
            SocketLobbySend.clickedJoinChannelRoomOrGame(channelId, RoomType.DiscordActivity);
            return;
        }
        // created private since the host has not joined yet; setup flow flips it via setPrivateRoomStateSync
        SocketLobbySend.clickedCreateRoom(RoomType.Standard, true);
    }
    onExitRoom(callback, forceExit) {
        if (this.pageOnNextUpdate == 1 && !forceExit) {
            var _this_roomPageController, _this_roomEditPageController;
            this.pageOnNextUpdate = 0;
            (_this_roomPageController = this.roomPageController) === null || _this_roomPageController === void 0 ? void 0 : _this_roomPageController.showView();
            return (_this_roomEditPageController = this.roomEditPageController) === null || _this_roomEditPageController === void 0 ? void 0 : _this_roomEditPageController.exitView();
        }
        showSimpleDialog({
            title: {
                key: 'strings:roomPage.leaveRoom.title'
            },
            body: {
                key: 'strings:roomPage.leaveRoom.body'
            },
            onConfirm: ()=>{
                var _this_roomSetupController;
                this.leaveRoom();
                (_this_roomSetupController = this.roomSetupController) === null || _this_roomSetupController === void 0 ? void 0 : _this_roomSetupController.roomSettingsController.setPrivateRoomStateSync(false);
                UIOnlineFriendController.userOnlineAndIdle();
                if (callback) callback();
            },
            showCancelBtn: true
        });
    }
    showRoomStep(roomController) {
        var _this_roomPageController, _this_roomSetupController, _this_roomEditPageController;
        if (this.roomPageController != roomController) (_this_roomPageController = this.roomPageController) === null || _this_roomPageController === void 0 ? void 0 : _this_roomPageController.hideView();
        if (this.roomSetupController != roomController) (_this_roomSetupController = this.roomSetupController) === null || _this_roomSetupController === void 0 ? void 0 : _this_roomSetupController.hideView();
        if (this.roomEditPageController != roomController) (_this_roomEditPageController = this.roomEditPageController) === null || _this_roomEditPageController === void 0 ? void 0 : _this_roomEditPageController.hideView();
    }
    clearRoom() {
        var _this_roomPageController, _this_roomSetupController, _this_roomEditPageController;
        (_this_roomPageController = this.roomPageController) === null || _this_roomPageController === void 0 ? void 0 : _this_roomPageController.hideView();
        (_this_roomSetupController = this.roomSetupController) === null || _this_roomSetupController === void 0 ? void 0 : _this_roomSetupController.exitView();
        (_this_roomEditPageController = this.roomEditPageController) === null || _this_roomEditPageController === void 0 ? void 0 : _this_roomEditPageController.exitView();
        this.pageOnNextUpdate = undefined;
        this.shouldOpenDiscordInviteOnEnteringRoomView = false;
        this.roomState = undefined;
    }
    leaveRoom() {
        if (this.roomState != undefined) UIRoomSettingsController.snapshotRoomSettings(this.roomState, socket.controller.session.id);
        window.location.hash = '';
        this.clearRoom();
        socket.roomClient.leave();
    }
    isUserOnCreateRoomFlow() {
        return this.pageOnNextUpdate != undefined;
    }
    // eslint-disable-next-line class-methods-use-this
    disableChatInput() {
        const chatInput = document.querySelector('input.m-room-players-chat-input');
        if (chatInput) {
            chatInput.blur();
            chatInput.disabled = true;
        }
    }
    isCreateRoomButNotAHost() {
        if (!this.isUserOnCreateRoomFlow()) return false;
        return !this.roomState.isHost(socket.controller.session.id);
    }
    handleSocketReconnection() {
        this.clearRoom();
        UIUrlController.accessGameFromLink(async (roomId)=>{
            await SocketLobbySend.accessGameFromLink(roomId);
        });
    }
    constructor(){
        this.pageOnNextUpdate = undefined;
        this.shouldOpenDiscordInviteOnEnteringRoomView = false;
    }
}
